import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import Tile from './Tile';

function SortableTile({ tile, disabled }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: tile.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    cursor: 'grab',
  };

  return (
    <div className="tileboard-tile" ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Tile tile={tile} />
    </div>
  );
};

export default SortableTile;
